<template>
	<div class="login-view">
		<div class="content">
			<el-form class="form" :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="60px"
				@keyup.enter.native="submitForm('loginForm')">
				<div class="title">
					<img class="logo" src="../../public/imoa.png" />
					<div>登录IMOA</div>
				</div>
				<el-form-item label="终端" prop="userName" v-show="false">
					<el-input type="terminal" v-model="loginForm.terminal" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item class="username-item" label="用户名" prop="userName">
					<el-input 
						class="login-input" 
						type="userName" 
						v-model="loginForm.userName" 
						autocomplete="off"
						placeholder="用户名"
						clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="密  码" prop="password">
					<el-input 
						class="login-input" 
						type="password" 
						v-model="loginForm.password" 
						autocomplete="off"
						placeholder="密  码"
						clearable
						show-password>
					</el-input>
				</el-form-item>
				<el-form-item class="btn-row">
					<div class="btn-row-inner">
						<div class="btn-group">
							<el-button class="login-btn" type="primary" @click="submitForm('loginForm')">登录</el-button>
							<el-button class="login-btn1" @click="goToRegister">注册</el-button>
						</div>
						<div class="captcha-group">
							<div class="captcha-image" @click="refreshCaptcha">
								{{ captchaA }} + {{ captchaB }} = ?
							</div>
							<el-input
								class="captcha-input"
								v-model="loginForm.captchaInput"
								placeholder="值"
								size="small"
							></el-input>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<icp></icp>
	</div>
</template>

<script>
import axios from 'axios'
import { OA_BASE_URL, OA_CLIENT_ID, OA_GRANT_TYPE, OA_TENANT_ID } from '../config/oa'
import Icp from '../components/common/Icp.vue'
export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUsername = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			}
			callback();

		};
		return {
			captchaA: Math.floor(Math.random() * 9) + 1,
			captchaB: Math.floor(Math.random() * 9) + 1,
			loginForm: {
				terminal: this.$enums.TERMINAL_TYPE.WEB,
				userName: '',
				password: '',
				captchaInput: ''
			},
			rules: {
				userName: [{
					validator: checkUsername,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (!this.loginForm.captchaInput) {
						this.$message.error("请输入验证码结果");
						return;
					}
					const payload = {
						terminal: this.loginForm.terminal,
						userName: this.loginForm.userName,
						password: this.loginForm.password,
						captchaA: this.captchaA,
						captchaB: this.captchaB,
						captchaResult: parseInt(this.loginForm.captchaInput, 10)
					};
					this.$http({
						url: "/login",
						method: 'post',
						data: payload
					})
					.then(async (data) => {
						// 保存密码到cookie(不安全)
						this.setCookie('username', this.loginForm.userName);
						this.setCookie('password', this.loginForm.password);
						// 保存token
						sessionStorage.setItem("accessToken", data.accessToken);
						sessionStorage.setItem("refreshToken", data.refreshToken);
						// 同步登录 ruoyi-mate，获取 OA 所需的 Admin-Token 和用户信息
						await this.syncRuoyiLogin(payload);
						this.$message.success("登录成功");
						this.$router.push("/home/chat");
					})

				}
			});
		},
		refreshCaptcha() {
			// 生成 1-9 之间的两个随机数
			this.captchaA = Math.floor(Math.random() * 9) + 1;
			this.captchaB = Math.floor(Math.random() * 9) + 1;
			this.loginForm.captchaInput = '';
		},
		goToRegister() {
			this.$router.push('/register');
		},
		// 参考 uniapp/common/oa/httptoRuoyimate.js，在 IM 登录成功后同步登录 ruoyi-mate
		async syncRuoyiLogin(loginForm) {
			try {
				if (!OA_BASE_URL) {
					console.warn('syncRuoyiLogin: 未配置 OA_BASE_URL，跳过 ruoyi-mate 同步登录');
					return;
				}
				const loginData = {
					username: loginForm.userName,
					password: loginForm.password,
					clientId: OA_CLIENT_ID,
					grantType: OA_GRANT_TYPE,
					tenantId: OA_TENANT_ID,
					code: '',
					uuid: ''
				};

				localStorage.removeItem('Admin-Token');
				localStorage.removeItem('ruoyi_user_info');
				console.log('syncRuoyiLogin: 开始向若依 OA 系统发送登录请求...', OA_BASE_URL, loginData);

				const loginRes = await axios.post(`${OA_BASE_URL}/auth/login`, loginData, {
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'isToken': 'false',
						'repeatSubmit': 'false'
					}
				});

				if (loginRes.status === 200 && loginRes.data && loginRes.data.code === 200) {
					const tokenData = loginRes.data.data || {};
					const token = tokenData.access_token || tokenData.token || loginRes.data.token;
					console.log('syncRuoyiLogin: ruoyi-mate 登录成功, token:', token);

					if (!token) {
						console.warn('syncRuoyiLogin: ruoyi-mate 登录成功但未返回 token:', loginRes.data);
						return;
					}

					localStorage.setItem('Admin-Token', token);

					// 使用 token 再获取一次用户信息
					const userInfoRes = await axios.get(`${OA_BASE_URL}/system/user/getInfo`, {
						headers: {
							'Content-Type': 'application/json;charset=utf-8',
							'Authorization': 'Bearer ' + token,
							'clientid': OA_CLIENT_ID
						}
					});

					if (userInfoRes.status === 200 && userInfoRes.data && userInfoRes.data.code === 200) {
						const userInfo = (userInfoRes.data.data && userInfoRes.data.data.user)
							|| userInfoRes.data.user
							|| (userInfoRes.data.data && userInfoRes.data.data.userId && userInfoRes.data.data.userName ? userInfoRes.data.data : null)
							|| userInfoRes.data;
						console.log('syncRuoyiLogin: ruoyi-mate 用户信息:', userInfo);
						localStorage.setItem('ruoyi_user_info', JSON.stringify(userInfo));
					} else {
						console.warn('syncRuoyiLogin: 获取 ruoyi-mate 用户信息失败:', userInfoRes.data);
					}
				} else {
					console.warn('syncRuoyiLogin: ruoyi-mate 登录失败:', loginRes.data);
				}
			} catch (e) {
				console.warn('syncRuoyiLogin: 同步登录 ruoyi-mate 失败，将不影响 IM 登录流程', e);
			}
		},
		getCookie(name) {
			let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			let arr = document.cookie.match(reg)
			if (arr) {
				return unescape(arr[2]);
			}
			return '';
		},
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		}

	},
	mounted() {
		this.loginForm.userName = this.getCookie("username");
		// cookie存密码并不安全，暂时是为了方便
		this.loginForm.password = this.getCookie("password");
	}
}
</script>

<style scoped lang="scss">
.login-view {
	width: 100%;
	height: 100%;
	background: #e1e6f0;
	background-size: cover;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px 16px;

	.content {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: stretch;
		max-width: 960px;
		width: 100%;

		/* 背景装饰块，让整体看起来更有层次感 */
		&::before {
			content: "";
			position: absolute;
			inset: 8%;
			border-radius: 32px;
			background: radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.09), transparent 55%),
				linear-gradient(135deg, rgba(15, 23, 42, 0.04), rgba(59, 130, 246, 0.02));
			z-index: 0;
		}

		.form {
			position: relative;
			z-index: 1;
			width: 420px;
			min-height: 360px;
			padding: 40px 40px 32px;
			background: #ffffff;
			box-shadow: 0 18px 45px rgba(15, 23, 42, 0.12);
			border-radius: 24px;
			border: none;
			overflow: hidden;

			.title {
				display: flex;
				justify-content: center;
				align-items: center;
				line-height: 1;
				margin: 8px 0 32px 0;
				font-size: 22px;
				font-weight: 600;
				letter-spacing: 1px;
				text-align: center;
				color: #111827;

				.logo {
					width: 32px;
					height: 32px;
					margin-right: 10px;
					border-radius: 8px;
				}
			}

			.login-input {
				width: 100%;
			}

			>>> .el-input__inner:focus,
			>>> .el-input__inner:hover {
				border-color: #d4def5 !important;
			}

			// 让表单标签左对齐，保证“用户名”和“密  码”的首字对齐
			>>> .el-form-item__label {
				text-align: left;
				color: #6b7280;
			}

			/* 专门控制“用户名”这一行 label 与 input 的间距，input 位置不动 */
			.username-item >>> .el-form-item__label {
				padding-right: 4px;
			}

			// 控制按钮与输入框的垂直间距
			.btn-row {
				margin-top: 18px;
			}

			.btn-row-inner {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 12px;
				height: auto;
				margin-top: 8px;
			}

			.btn-group {
				display: flex;
				gap: 0;
				flex: 0 0 190px;
			}

			/* 登录 / 注册按钮等宽圆角 */
			.login-btn,
			.login-btn1 {
				flex: 1;
				height: 32px;
				border-radius: 999px;
				font-size: 13px;
			}

			.login-btn {
				background-color: #e1e6f0 !important;
				border-color: #e1e6f0 !important;
				color: #111827 !important;

				&:hover,
				&:focus,
				&:active {
					background-color: #d4def5 !important;
					border-color: #d4def5 !important;
					color: #111827 !important;
					box-shadow: none !important;
				}
			}

			.login-btn1 {
				border-color: #d4def5 !important;
				color: #111827 !important;

				&:hover,
				&:focus,
				&:active {
					background-color: #f7f8fc !important;
					border-color: #d4def5 !important;
					color: #111827 !important;
					box-shadow: none !important;
				}
			}

			.captcha-group {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				flex: 1;
				gap: 8px;
			}

			.captcha-image {
				min-width: 90px;
				height: 32px; /* 与按钮高度一致 */
				padding: 0 10px;
				border-radius: 999px; /* 形状跟按钮一致，更协调 */
				background: #e5edff;
				color: #2563eb;
				font-weight: 600;
				font-size: 13px;
				text-align: center;
				cursor: pointer;
				user-select: none;
			}

			.captcha-input {
				width: 42px; /* 稍微加宽，保证“结果”两个字完整显示 */
			}

			/* 让验证码输入框高度与按钮一致，并保证右侧对齐 */
			.captcha-input >>> .el-input__inner {
				height: 32px;
				line-height: 32px;
				padding: 0 8px; /* 减少左右留白，文字更居中 */
				font-size: 10px !important; /* 确保“结果”字体比上面的输入框小一档 */
			}
		}
	}
}
</style>
